import * as z from 'zod';
import { Get as Get$1 } from './bid-contract-surety-quote-preview.dto.mjs';
import * as bidContractSuretyQuotePreview_dto from './bid-contract-surety-quote-preview.dto.mjs';
export { bidContractSuretyQuotePreview_dto as Bid };
import { Get as Get$3 } from './bid-to-final-contract-surety-quote-preview.dto.mjs';
import * as bidToFinalContractSuretyQuotePreview_dto from './bid-to-final-contract-surety-quote-preview.dto.mjs';
export { bidToFinalContractSuretyQuotePreview_dto as BidToFinal };
import { Get as Get$2 } from './final-contract-surety-quote-preview.dto.mjs';
import * as finalContractSuretyQuotePreview_dto from './final-contract-surety-quote-preview.dto.mjs';
export { finalContractSuretyQuotePreview_dto as Final };

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.discriminatedUnion("contractSuretyType", [
            Get$1.Response.schema,
            Get$2.Response.schema,
            Get$3.Response.schema,
        ]);
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));

export { Get };
